import styled from 'styled-components';
import { getColorByType } from '../../constants/colors';

export const Container = styled.div`
  position: absolute;
  top: 2%;
  width: 100%;
  z-index: 99;
  display: flex;
  justify-content: center;

  @media (max-width: 1024px) {
    top: 5%;
  }

  @media (max-width: 768px) {
    padding: 0 5px;
  }
`;

export const Box = styled.div`
  width: 98%;
  display: flex;
  justify-content: space-between;
  @media (max-width: 1024px) {
  }

  @media (max-width: 1200px) {
    width: 100%;
    gap: 15px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 32%;
`;

export const Button = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'type',
})<{ isActive: boolean; type: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: none;
  cursor: pointer;
  width: 100%;
  height: 70px;
  background-color: ${({ isActive }) => (isActive ? '#fff' : '#e0e0e0')};
  color: ${({ isActive, type }) => (isActive ? getColorByType(type) : '#333')};
  font-family: 'Oswald', sans-serif;
  font-size: 25px;
  text-transform: uppercase;
  border-radius: ${({ isActive }) => (isActive ? '10px 10px 0 0' : '10px')};

  &:hover {
    background-color: #fff;
  }

  img {
    filter: ${({ isActive }) => (isActive ? 'none' : 'grayscale(100%)')};
  }

  p {
    margin: 0;
  }

  @media (max-width: 1200px) {
    flex-direction: column;
    font-size: 14px;
    gap: 0;

    border-radius: ${({ isActive }) => isActive && '10px'};

    img {
      width: 30px;
    }
  }
`;

export const InfoContainer = styled.div<{ type: string }>`
  position: relative;
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  text-align: center;
  border-radius: 0 0 10px 10px;
  border-color: ${({ type }) => getColorByType(type)};
  background-color: ${({ type }) => getColorByType(type)};
  color: #ffffff;

  display: flex;
  justify-content: space-around;
  align-items: end;

  &::after {
    content: '';
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #fff;
  }

  @media (max-width: 1200px) {
    border-radius: 10px;
    position: absolute;
    width: 100%;
    margin-top: 10px;
    top: 100%;
    left: 0;
    flex-direction: row;
    justify-content: start;
    flex-wrap: wrap;

    &::after {
      display: none;
    }
  }
`;

export const WrapperInfoBlock = styled.div<{ isMain?: boolean }>`
  display: flex;
  justify-content: center;

  width: ${({ isMain }) => (isMain ? '100%' : '90%')};
  font-size: ${({ isMain }) => (isMain ? '2rem' : '1.5rem')};
  border-right: 1px solid rgba(255, 255, 255, 0.5);

  &:last-child {
    border-right: none;
    border-bottom: none;
  }

  @media (max-width: 1500px) {
    font-size: ${({ isMain }) => (isMain ? '1.75rem' : '1rem')};
  }

  @media (max-width: 1200px) {
    justify-content: ${({ isMain }) => (isMain ? 'start' : 'start')};
    border-right: ${({ isMain }) => isMain && 'none'};
    border-bottom: ${({ isMain }) => isMain && '1px solid rgba(255, 255, 255, 0.5)'};
    width: ${({ isMain }) => (isMain ? '100%' : '27%')};
    font-size: ${({ isMain }) => (isMain ? '1.75rem' : '1rem')};
    margin-bottom: ${({ isMain }) => (isMain ? '10px' : '0')};
    margin-right: ${({ isMain }) => !isMain && '15px'};
  }

  @media (max-width: 260px) {
    width: ${({ isMain }) => (isMain ? '100%' : '100%')};
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  }
`;

export const InfoBlock = styled.div<{ isMain?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;

  @media (max-width: 1200px) {
    flex-direction: ${({ isMain }) => isMain && 'row'};
    align-items: ${({ isMain }) => isMain && 'center'};
    gap: ${({ isMain }) => isMain && '20px'};
  }
`;

export const LargeText = styled.div`
  font-weight: bold;
  white-space: nowrap;
`;

// Period caption under a headline figure ("since 2012", "in 2025") so a number
// is never shown without the period it covers (CLAUDE.md §10). Sized a step
// below SmallText at every breakpoint.
export const PeriodHint = styled.div`
  width: 100%;
  font-size: 11px;
  line-height: 12px;
  margin-top: 2px;
  opacity: 0.85;
  white-space: nowrap;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;

  @media (max-width: 1700px) {
    font-size: 10px;
  }

  @media (max-width: 1400px) {
    font-size: 9px;
  }

  @media (max-width: 300px) {
    font-size: 7px;
  }
`;

export const SmallText = styled.div`
  width: 100%;
  font-size: 15px;
  margin-top: 2px;
  white-space: nowrap;

  @media (max-width: 1700px) {
    font-size: 12px;
  }

  @media (max-width: 1400px) {
    font-size: 10px;
  }

  @media (max-width: 300px) {
    font-size: 8px;
  }

  font-family: 'Roboto', sans-serif;
  line-height: 15px;
  font-weight: 400;
`;
